import React, { ReactNode, useState } from 'react';

import { FormComponent } from 'components';
import { useInfiniteScroll } from 'hooks';
import { AdminsQuery } from 'queries';
import * as M from 'styles/mobile';
import { SearchAdminFilterType } from 'types';
import * as S from './style';

interface Props {
  title?: ReactNode;
}

function MobileList({ title }: Props) {
  const [filter, setFilter] = useState<SearchAdminFilterType>({});

  const { data, hasNextPage, isFetchingNextPage, fetchNextPage, isLoading } =
    AdminsQuery.useGetInfinite(filter);
  const sentinelRef = useInfiniteScroll({
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  const admins = data ?? [];

  return (
    <>
      <div css={M.stickyTop}>
        {title}
        <FormComponent.Form
          submit={(d: SearchAdminFilterType) =>
            setFilter({ name: d.name?.trim() || undefined })
          }
        >
          <FormComponent.SearchInput
            name="name"
            placeholder="이름으로 검색해주세요"
          />
        </FormComponent.Form>
      </div>
      <div css={M.list}>
        {admins.map((admin) => {
          const roles = admin.roles ?? [];
          return (
            <div key={admin.id} css={M.listItemStatic}>
              <div css={M.listRow}>
                <div css={S.titleWrap}>
                  <p css={S.title}>
                    {admin.username}
                    {admin.name ? ` · ${admin.name}` : ''}
                  </p>
                </div>
                <span css={M.tag(admin.isActive ? 'success' : 'grey')}>
                  {admin.isActive ? '활성' : '비활성'}
                </span>
              </div>
              {admin.email && <p css={S.meta}>{admin.email}</p>}
              <p css={S.meta}>
                {roles.length > 0 ? roles.map((r) => r.name).join(', ') : '-'}
              </p>
            </div>
          );
        })}
        {!isLoading && admins.length === 0 && (
          <p css={M.empty}>등록된 어드민이 없습니다</p>
        )}
        {isFetchingNextPage && <p css={M.empty}>불러오는 중...</p>}
      </div>
      <div ref={sentinelRef} css={M.sentinel} />
    </>
  );
}

export default MobileList;
